import { useEffect, useRef, useState } from "react";
import useHandleJSONKeys from "./useHandleJSONKeys";

const initialValue = '{\n  "": \n}';

/**
 * existingObject - An existing object you want to appear in the editor.
 * readOnly - Whether or not the user can edit the object.
 * onChange - Function that should have one parameter. Passes along the new Object or the string "failed"
 * reset - State value from parent. Should start at 0. Whenever this value is updated, the TextEditor is reset.
 */
const JSONTextEditor = ({
  existingObject,
  readOnly = false,
  onChange,
  reset = 0,
  format = 0,
  disabled = false,
}) => {
  const [value, setValue] = useState(initialValue);
  const textAreaRef = useRef();
  const valueRef = useRef();
  valueRef.current = value;

  useEffect(() => {
    if (!existingObject) return;
    const convertedJSON = JSON.stringify(existingObject, null, "  ");
    setValue(convertedJSON);
  }, [existingObject]);

  useEffect(() => {
    textAreaRef.current.setSelectionRange(
      textAreaRef.current.selectionStart,
      textAreaRef.current.selectionStart
    );
  }, [value]);

  // Handle reset from Parent
  useEffect(() => {
    if (reset === 0) return;

    const convertedJSON = JSON.stringify(existingObject, null, "  ");
    setValue(convertedJSON);
  }, [reset, existingObject]);

  // Handle format from Parent
  useEffect(() => {
    if (format === 0) return;

    const object = convertToObject(valueRef.current);

    if (object === "Failed") return;

    const convertedJSON = JSON.stringify(object, null, "  ");
    setValue(convertedJSON);
  }, [format]);

  const isValidJSON = () => convertToObject(value) !== "Failed";

  const handleChange = (val, cursorPosition = null) => {
    setValue(val);

    if (typeof onChange === "function") {
      const convertedJSON = convertToObject(val);
      onChange(convertedJSON);
    } else {
      console.log(
        "Invalid onChange function passed to JSONTextEditor component."
      );
    }

    if (cursorPosition) {
      textAreaRef.current.selectionEnd = cursorPosition;
      textAreaRef.current.selectionStart = cursorPosition;
    }
  };

  const convertToObject = (JSONString) => {
    if (typeof JSONString !== "string") {
      console.error(
        "Passed non-string to convertToObject function",
        JSONString
      );
      return "Failed";
    }

    let val = JSONString;
    val = val.replace("\n", "");

    try {
      val = JSON.parse(val);
      return val;
    } catch {
      return "Failed";
    }
  };

  //useHandleJSONKeys(textAreaRef, handleChange);

  return (
    <>
      <textarea
        rows="10"
        ref={textAreaRef}
        className={`json-textarea ${isValidJSON() ? "" : "json-error"}`}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        readOnly={readOnly}
        disabled={disabled}
      ></textarea>
    </>
  );
};

export default JSONTextEditor;
